import { createContext, useContext, useState } from "react";

const BookingContext = createContext();

export const BookingProvider = ({ children }) => {
  const [prefill, setPrefill] = useState(null);
  const [vehicle, setVehicle] = useState("");
  return (
    <BookingContext.Provider value={{ prefill, setPrefill, vehicle, setVehicle }}>
      {children}
    </BookingContext.Provider>
  );
};

export const useBooking = () => useContext(BookingContext);
